import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router";

import App from "./App";
import ErrorPage from "./pages/ErrorPage";
import "./App.css";
import "./index.css"

// Lazy load pages
const Home = lazy(() => import("./pages/Home"));
// const About = lazy(() => import("./pages/About"));
// const Projects = lazy(() => import("./pages/Projects"));
// const Contact = lazy(() => import("./pages/Contact"));

// Simple spinner component
function Spinner() {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <Home /> },
      // { path: "about", element: <About /> },
      // { path: "projects", element: <Projects /> },
      // { path: "contact", element: <Contact /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Suspense fallback={<Spinner />}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);
